/* import __COLOCATED_TEMPLATE__ from './reassign.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Reassign = templateOnlyComponent<Signature>();
export default Reassign;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::UserMenu::Reassign': typeof Reassign;
    'inbox2/user-menu/reassign': typeof Reassign;
  }
}
